"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserProvider = exports.UserContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _axios = _interopRequireDefault(require("axios"));
var _loader = require("../components/molecules/loader");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var UserContext = exports.UserContext = /*#__PURE__*/(0, _react.createContext)();
var UserProvider = exports.UserProvider = function UserProvider(props) {
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    userData = _useState2[0],
    setUserData = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoggedIn = _useState4[0],
    setIsLoggedIn = _useState4[1];
  var _useState5 = (0, _react.useState)(),
    _useState6 = _slicedToArray(_useState5, 2),
    userWineplanData = _useState6[0],
    setUserWineplanData = _useState6[1];
  var _useState7 = (0, _react.useState)(),
    _useState8 = _slicedToArray(_useState7, 2),
    userUNLSubscriptionData = _useState8[0],
    setUserUNLSubscriptionData = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    userHasWP = _useState10[0],
    setUserHasWP = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    userHasUNL = _useState12[0],
    setUserHasUNL = _useState12[1];
  (0, _react.useEffect)(function () {
    fetchUserData();
  }, []);
  (0, _react.useEffect)(function () {
    if (userData && userData.securityStatus >= 4) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, [userData]);
  var fetchUserData = function fetchUserData() {
    _axios["default"].get('/api/user/details').then(function (response) {
      setUserData(response.data.response);
    });
  };
  var fetchUserWineplans = function fetchUserWineplans() {
    _axios["default"].get('/api/user/subscriptions/wineplans/list').then(function (response) {
      setUserWineplanData(response.data.response);
      checkUserWP(response.data.response);
    });
  };
  var checkUserWP = function checkUserWP(WPdata) {
    if ((WPdata === null || WPdata === void 0 ? void 0 : WPdata.winePlanSubscriptions.length) > 0) {
      setUserHasWP(WPdata.winePlanSubscriptions.some(function (item) {
        return item.status === 'ACTIVE' || item.status === 'REQUESTED';
      }));
    }
  };
  var fetchUserUNLSubscriptions = function fetchUserUNLSubscriptions() {
    _axios["default"].get('/api/user/subscriptions/subscription/list').then(function (response) {
      setUserUNLSubscriptionData(response.data.response);
      checkUserUNL(response.data.response);
    });
  };
  var checkUserUNL = function checkUserUNL(UNLdata) {
    if ((UNLdata === null || UNLdata === void 0 ? void 0 : UNLdata.generalSubscriptions.length) > 0) {
      setUserHasUNL(UNLdata.generalSubscriptions.some(function (item) {
        return item.types.includes('FREESHIP') && (item.status === 'ACTIVE' || item.status === 'REQUESTED' || item.status === 'SUSPENDED');
      }));
    }
  };
  return /*#__PURE__*/_react["default"].createElement(UserContext.Provider, {
    value: {
      userData: userData,
      isLoggedIn: isLoggedIn,
      fetchUserData: fetchUserData,
      fetchUserWineplans: fetchUserWineplans,
      fetchUserUNLSubscriptions: fetchUserUNLSubscriptions,
      userWineplanData: userWineplanData,
      userUNLSubscriptionData: userUNLSubscriptionData,
      userHasWP: userHasWP,
      userHasUNL: userHasUNL
    }
  }, userData ? props.children : /*#__PURE__*/_react["default"].createElement(_loader.Loader, null));
};